import { rankings } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            热门榜单
          </h2>
          <p className="text-sm text-foreground-600">当前最受欢迎的赛事视频排行</p>
        </div>

        <div className="rounded-2xl bg-background-100 overflow-hidden">
          {rankings.map((item, index) => (
            <a
              key={item.id}
              href="#media"
              className={`flex items-center gap-4 p-4 md:p-5 hover:bg-background-200/50 transition-colors cursor-pointer ${
                index < rankings.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 text-sm font-bold ${
                  item.rank === 1
                    ? 'bg-primary-500 text-white'
                    : item.rank === 2
                    ? 'bg-accent-500 text-white'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-white'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-medium text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span
                    className={`text-xs ${
                      item.change === 'up'
                        ? 'text-primary-500'
                        : item.change === 'down'
                        ? 'text-foreground-400'
                        : 'text-foreground-400'
                    }`}
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i
                        className={`${
                          item.change === 'up'
                            ? 'ri-arrow-up-line'
                            : item.change === 'down'
                            ? 'ri-arrow-down-line'
                            : 'ri-subtract-line'
                        }`}
                      ></i>
                    </span>
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{item.category}</span>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50 text-foreground-400 flex-shrink-0 hover:text-primary-500 transition-colors">
                <i className="ri-play-circle-line text-lg"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}